export const environment = {
	production: true,
	apiUrl: 'https://api.dev.mtpro.mapcom.com/api',
	instrumentationKey: '0b213568-c09d-4386-9e80-2abde3e03c51',
};
